<i18n>
{
  "cl": {
    "sectionFilter": "Filtrar por sección",
    "userFeatureFilter": "Filtrar permisos",
    "create": "Crear sección",
    "permissions": "Usted no tiene permisos para ejecutar este menú",
    "onlyRead": "Lectura",
    "readWrite": "Escritura",
    "addTag": "Agregar un tag",
    "saveSection": "Aplicar",
    "cancelSection": "Cancelar",
    "deleteSection": "Eliminar Sección",
    "confirmDeleteSection": "¿Seguro quieres eliminar la sección?",
    "add": "Para agregar",
    "delete": "Para eliminar",
    "addTagMessage": "Agrega un tag en filtrar permisos para poder añadir un nuevo permiso.",
    "serverError": "Ocurrió un error de comunicación con el servidor.",
    "sectionDeleted": "Sección eliminada",
    "sectionSaved": "Sección guardada"
  },
  "pe": {
    "sectionFilter": "Filtrar por sección",
    "userFeatureFilter": "Filtrar permisos",
    "create": "Crear sección",
    "permissions": "Usted no tiene permisos para ejecutar este menú",
    "onlyRead": "Lectura",
    "readWrite": "Escritura",
    "addTag": "Agregar un tag",
    "saveSection": "Aplicar",
    "cancelSection": "Cancelar",
    "deleteSection": "Eliminar Sección",
    "confirmDeleteSection": "¿Seguro quieres eliminar la sección?",
    "add": "Para agregar",
    "delete": "Para eliminar",
    "addTagMessage": "Agrega un tag en filtrar permisos para poder añadir un nuevo permiso.",
    "serverError": "Ocurrió un error de comunicación con el servidor.",
    "sectionDeleted": "Sección eliminada",
    "sectionSaved": "Sección guardada"
  },
  "br": {
    "sectionFilter": "Filtrar por seção",
    "userFeatureFilter": "Filtrar permissões",
    "create": "Criar seção",
    "permissions": "Você não tem permissão para executar este menu",
    "onlyRead": "Leitura",
    "readWrite": "Escrita",
    "addTag": "Adicionar uma etiqueta",
    "saveSection": "Aplicar",
    "cancelSection": "Cancelar",
    "deleteSection": "Excluir seção",
    "confirmDeleteSection": "Tem certeza de que deseja excluir a seção?",
    "add": "Adicionar",
    "delete": "Para eliminar",
    "addTagMessage": "Adicione uma tag em permissões de filtro para poder adicionar uma nova permissão.",
    "serverError": "Ocorreu um erro de comunicação com o servidor.",
    "sectionDeleted": "Seção removida",
    "sectionSaved": "Seção salva"
  }
}
</i18n>
<template>
  <div>
    <div v-if="!checkUserFeature('nav.settings.sections')" id="notPermissions">
      <p>{{ $t('permissions') }}</p>
    </div>
    <div v-else>
      <div id="search-container" class="feature card-item">
        <Spinner id="spinner" :is-loading="isLoading" />
        <div v-if="!showList && !isLoading" id="features-container">
          <div class="columns is-mobile my-0">
            <b-field expanded class="column">
              <b-taginput
                id="section-filter-input"
                v-model="sectionFilters"
                rounded
                size="is-small"
                :data="filteredSectionTags"
                autocomplete
                :allow-new="true"
                :open-on-focus="true"
                field="feature.name22"
                :placeholder="$t('sectionFilter')"
                close-type="is-success"
                @typing="getFilteredTags('section',$event)" />
            </b-field>
            <div class="column is-narrow">
              <b-button
                id="back-button"
                icon-left="fa-solid fa-plus"
                class="is-primary is-light is-small is-rounded"
                @click="() => createSection()">
                <span class="is-size-7 has-text-weight-normal">
                  {{ $t('create') }}
                </span>
              </b-button>
            </div>
          </div>
          <div
            v-for="section in sectionToShow"
            :id="`section-${section._id}`"
            :key="section._id"
            class="feature card-item shadowless">
            <div class="feature-body">
              <div class="section-detail">
                <div>
                  <div v-if="checkExtended(section)">
                    <b-input
                      id="input-name"
                      v-model="section.name"
                      class="outlinenone"
                      size="is-small"
                      style="max-width: 300px;" />
                    <b-input
                      v-model="section.description"
                      size="is-small"
                      style="max-width: 300px;" />
                  </div>
                  <div v-else>
                    <p id="sectionName" class="is-size-6 has-text-primary">
                      {{ section.name }}
                    </p>
                    <p class="is-size-7">
                      {{ section.description }}
                    </p>
                  </div>
                </div>
                <div class="pt-1">
                  <a
                    :id="`gear-button-${section._id}`"
                    href="#"
                    @click="expandDetailSection(section)">
                    <span class="fa-solid fa-gear fa-xl" />
                  </a>
                </div>
              </div>
              <div v-if="checkExtended(section)" class="mt-4">
                <b-taginput
                  :id="`tag-section-${section._id}`"
                  v-model="section.tags"
                  ellipsis
                  icon="label"
                  :placeholder="$t('addTag')"
                  size="is-small"
                  class="mb-1" />
                <div class="mt-0">
                  <div class="columns is-mobile my-0">
                    <b-field expanded class="column is-narrow mb-1">
                      <b-select
                        v-model="selectedSectionMode"
                        size="is-small"
                        rounded
                        @input="onChangeSelectedSectionMode(section)">
                        <option
                          v-for="(option, i) in sectionModeOptions"
                          :key="i"
                          :value="option">
                          {{ option === 'read' ? $t('onlyRead'): $t('readWrite') }}
                        </option>
                      </b-select>
                    </b-field>
                    <div class="column">
                      <b-taginput
                        id="filter-user-features-input"
                        v-model="userFeaturesFilter"
                        rounded
                        size="is-small"
                        :data="userFeaturesTagList"
                        autocomplete
                        :allow-new="true"
                        :open-on-focus="true"
                        field="section.name22"
                        :placeholder="$t('userFeatureFilter')"
                        close-type="is-success"
                        @typing="getFilteredTags('userFeature',$event)" />
                    </div>
                  </div>
                </div>
                <p v-if="checkEmptySectionMode(section)" class="is-size-7 place-items: center">
                  {{ $t('addTagMessage') }}
                </p>
                <div>
                  <div
                    v-for="feature in userFeaturesToShow"
                    :id="`feature-$.name}`"
                    :key="feature.name"
                    class="feature card-item shadowless green">
                    <div class="feature-body">
                      <b-field class="check is-pulled-right">
                        <b-switch
                          :id="`switch-${feature.name}-${feature.allowed}`"
                          v-model="feature.allowed"
                          type="is-success"
                          size="is-small"
                          @input="changeUserFeatureState(feature, section)" />
                      </b-field>
                      <b-field v-if="feature.status">
                        <b-tag
                          v-if="feature.status === 'add'"
                          class="mb-3"
                          type="is-primary is-light"
                          rounded>
                          {{ $t('add') }}
                        </b-tag>
                        <b-tag
                          v-if="feature.status === 'delete'"
                          class="mb-3"
                          type="is-danger is-light"
                          rounded>
                          {{ $t('delete') }}
                        </b-tag>
                      </b-field>
                    </div>
                    <p v-if="feature.status !== 'delete' && feature.status !== undefined" class="is-size-6 has-text-primary">{{ feature.name }}</p>
                    <p v-if="feature.status === 'delete' || feature.status === undefined" class="is-size-6 has-text-grey-light">{{ feature.name }}</p>
                    <p v-if="feature.status !== 'delete' && feature.status !== undefined" class="is-size-7 has-text-dark">{{ feature.description }}</p>
                    <p v-if="feature.status === 'delete' || feature.status === undefined" class="is-size-7 has-text-grey-light">{{ feature.description }}</p>
                  </div>
                  <div class="pt-4 pb-6">
                    <b-button
                      id="save-button"
                      :disabled="blockSave || !checkSectionChanges(section)"
                      class="is-button-primary is-small is-rounded is-pulled-right"
                      @click="applySectionsChanges(section)">
                      <span>
                        {{ $t('saveSection') }}
                      </span>
                    </b-button>
                    <b-button
                      id="cancel-button"
                      class="is-text mr-4 pb-3 is-pulled-right"
                      @click="expandDetailSection(section)">
                      <span>
                        {{ $t('cancelSection') }}
                      </span>
                    </b-button>
                    <b-button
                      v-if="!confirmDelete"
                      id="ask-button"
                      class="is-text mr-4 pb-3 is-pulled-left"
                      @click="askConfirmDelete()">
                      <span>
                        {{ $t('deleteSection') }}
                      </span>
                    </b-button>
                    <div v-else>
                      <p class="is-text mr-4 pb-3 is-pulled-left">
                        {{ $t('confirmDeleteSection') }}
                      </p>
                      <b-button
                        id="delete-button"
                        class="is-button-primary is-small is-rounded is-pulled-left"
                        @click="deleteSection(section);askConfirmDelete()">
                        <span>
                          Si
                        </span>
                      </b-button>
                      <b-button
                        id="ask-button"
                        class="is-text mr-4 pb-3 is-pulled-left"
                        @click="askConfirmDelete()">
                        <span>
                          No
                        </span>
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAllUserFeatures, deleteUserFeatureSection, getAllUserFeatureSections, createlUserFeatureSection, updatelUserFeatureSection } from '@/application/services/api-clients/users';
import Spinner from '@/ui/components/Spinner.vue';
import notification from '@/ui/mixins/notification';
import userFeatures from '@/ui/mixins/user-features';

export default {
  name: 'Sections',
  components: { Spinner },
  mixins: [notification, userFeatures],
  data() {
    return {
      confirmDelete: false,
      toast: this.$buefy.toast,
      blockSave: false,
      openName: false,
      openDescription: false,
      openTags: false,
      tagChanged: false,
      sectionToShow: [],
      userFeaturesToShow: [],
      selectedSectionMode: 'read',
      extendedSectionDetailsId: '',
      sections: [],
      sectionFilters: [],
      userFeatures: [],
      userFeaturesTagsList: [],
      userFeaturesFilter: [],
      showList: false,
      isLoading: false,
      filteredSectionTags: [],
      sectionTagsList: [],
      finder: this.finderUsers,
      cleaner: this.cleanerUsers,
      userFeaturesTagList: [],
      sectionModeOptions: [
        'read', 'write'
      ]
    };
  },
  watch: {
    sectionFilters: {
      immediate: true,
      deep: true,
      handler() {
        this.applySectionFilters();
      }
    },
    userFeaturesFilter: {
      immediate: true,
      deep: true,
      handler() {
        this.applyUserFeaturesFilters();
      }
    }
  },
  async mounted() {
    this.isLoading = true;
    await this.getFeatures();
    await this.getSections();
    this.isLoading = false;
  },
  methods: {
    showError() {
      this.toast.open({
        position: 'is-top-right',
        message: this.$t('serverError'),
        type: 'is-danger',
        duration: 5000
      });
    },
    showInfo(message) {
      this.toast.open({
        position: 'is-top-right',
        message,
        type: 'is-info',
        duration: 3000
      });
    },
    askConfirmDelete() {
      this.confirmDelete = !this.confirmDelete;
    },
    async deleteSection(sectionIn) {
      if (!sectionIn.new) {
        try {
          await deleteUserFeatureSection(sectionIn);
          this.sections = this.sections.filter(section => section._id !== sectionIn._id);
          this.setSections();
          this.showInfo(this.$t('sectionDeleted'));
          this.$emit('sectionUpdate');
        } catch (_error) {
          this.showError();
        }
      } else {
        this.sections = this.sections.filter(section => section._id !== sectionIn._id);
        this.setSections();
        this.showInfo(this.$t('sectionDeleted'));
      }
    },
    checkEmptySectionMode(section) {
      return !section[this.selectedSectionMode].length && !this.userFeaturesToShow.length;
    },
    checkSectionChanges(section) {
      const tagsSameLength = section.originalTags.length === section.tags.length;
      const tagsSameNames = !section.originalTags.find(originalTag => !section.tags.includes(originalTag));
      const tagsChanged = !tagsSameLength || !tagsSameNames;
      const nameChanged = section.originalName !== section.name;
      const descriptionChanged = section.originalDescription !== section.description;
      const sectionUserFeaturesChanged = !!this.userFeaturesToShow.find(feature => ['delete', 'add'].includes(feature.status));
      return sectionUserFeaturesChanged || tagsChanged || nameChanged || descriptionChanged;
    },
    // Se cambia el estado de los user features en userFeaturesToShow
    // Se pone flag changed en true
    changeUserFeatureState(featureIn, section) {
      const wasInSection = section[this.selectedSectionMode].includes(featureIn._id);
      const index = this.userFeaturesToShow.findIndex(feature => feature._id === featureIn._id);
      if (wasInSection) this.userFeaturesToShow[index].status = featureIn.allowed ? 'preserve' : 'delete';
      else this.userFeaturesToShow[index].status = featureIn.allowed ? 'add' : undefined;
      this.userFeaturesToShow.push({});
      this.userFeaturesToShow.pop();
    },
    collapseInputSections() {
      this.openName = false;
      this.openDescription = false;
      this.openTags = false;
    },
    modifySection(sectionOld, sectionNew) {
      const index = this.sections.findIndex(section => section._id === sectionOld._id);
      this.sections[index] = sectionNew;
      this.extendedSectionDetailsId = sectionNew._id;
    },
    // Se agregan los user features a la sección en el modo correspondiente
    // Se actualiza los user features, a ser mostrados, para cambiar el estado a preserve o indefinido segun el caso
    // Se limpian los filtros de user features
    async applySectionsChanges(section) {
      const userFeaturesToAdd = this.userFeaturesToShow.filter(feature => feature.status === 'add');
      const idsToAdd = userFeaturesToAdd.map(feature => feature._id);
      const userFeaturesToDelete = this.userFeaturesToShow.filter(feature => feature.status === 'delete');
      const idsToDelete = userFeaturesToDelete.map(feature => feature._id);
      // eslint-disable-next-line no-param-reassign
      section[this.selectedSectionMode] = section[this.selectedSectionMode].concat(idsToAdd);
      // eslint-disable-next-line no-param-reassign
      section[this.selectedSectionMode] = section[this.selectedSectionMode].filter(featureId => !idsToDelete.includes(featureId));
      // Se envía al backend el PATCH de la sección o el POST. Si es post borrar el _id y asegurarse de reemplazar la sección por la retornada.
      this.blockSave = true;
      try {
        const response = section.new ? await createlUserFeatureSection(section) : await updatelUserFeatureSection(section);
        this.modifySection(section, response[0]);
        this.blockSave = false;
        // Si todo sale bien se cambian los add y los delete a preserve
        this.userFeaturesToShow.forEach(feature => {
        // eslint-disable-next-line no-param-reassign
          if (['add'].includes(feature.status)) feature.status = 'preserve';
          // eslint-disable-next-line no-param-reassign
          if (['delete'].includes(feature.status)) feature.status = undefined;
        });
        this.userFeaturesToShow.push({});
        this.userFeaturesToShow.pop();
        this.cleanUserFilters();
        this.setSections();
        this.collapseInputSections();
        this.$emit('sectionUpdate');
        this.showInfo(this.$t('sectionSaved'));
      } catch (_error) {
        this.blockSave = false;
        this.showError();
      }
    },
    cleanAllSectionFields() {
      this.sectionToShow.forEach(section => {
        // eslint-disable-next-line no-param-reassign
        section.tags = JSON.parse(JSON.stringify(section.originalTags));
        // eslint-disable-next-line no-param-reassign
        section.name = section.originalName;
        // eslint-disable-next-line no-param-reassign
        section.description = section.originalDescription;
      });
    },
    cancelSectionChanges(section) {
      this.cleanUserFeatures(section);
      this.cleanAllSectionFields();
      this.getUserFeaturesToShow(section);
      this.collapseInputSections();
      this.selectedSectionMode = 'read';
      this.confirmDelete = false;
    },
    applyUserFeaturesFilters() {
      const newUserFeaturesToShow = this.userFeaturesToShow.filter(userFeature => userFeature.status);
      const filteredUserFeatures = this.userFeatures.filter(feature => {
        const isName = this.compareArrays(this.userFeaturesFilter, feature.name);
        const isTag = this.compareArrays(this.userFeaturesFilter, feature.tags);
        const isDescription = this.compareArrays(this.userFeaturesFilter, feature.description);
        const isNotInSection = !feature.status;
        return (isName || isTag || isDescription) && isNotInSection;
      });
      this.userFeaturesToShow = newUserFeaturesToShow.concat(filteredUserFeatures);
    },
    applySectionFilters() {
      // Si existe una sección abierta, la colapso
      if (this.extendedSectionDetailsId) {
        this.expandDetailSection(this.sections.find(section => section._id === this.extendedSectionDetailsId));
      }
      // Si no hay filtros, muestro todas las secciones
      if (!this.sectionFilters || this.sectionFilters.length === 0) {
        this.sectionToShow = this.sections;
      } else {
        const filteredSections = this.sections.filter(section => {
          const isName = this.compareArrays(this.sectionFilters, section.name);
          const isTag = this.compareArrays(this.sectionFilters, section.tags);
          const isDescription = this.compareArrays(this.sectionFilters, section.description);
          return isName || isTag || isDescription;
        });
        this.sectionToShow = filteredSections;
      }
    },
    // Se cargan los user features de la sección en userFeaturesToShow para ser mostrado en el modo y sección seleccionados
    getUserFeaturesToShow(section) {
      const userFeaturesInFilterMode = section[this.selectedSectionMode];
      this.userFeaturesToShow = this.userFeatures
        .filter(userFeature => userFeaturesInFilterMode.includes(userFeature._id))
        .map(userFeature => {
          // eslint-disable-next-line no-param-reassign
          userFeature.allowed = true;
          // eslint-disable-next-line no-param-reassign
          userFeature.status = 'preserve'; // add, delete, preserve
          return userFeature;
        });
    },
    cleanSectionFilters() {
      this.filters = [];
    },
    cleanUserFilters() {
      this.userFeaturesFilter = [];
    },
    // Recorre los user features guardados del backend reseteando el allowed y el status de estos.
    // Elimina los filtros de user features.
    cleanUserFeatures() {
      this.userFeatures.forEach(userFeature => {
        // eslint-disable-next-line no-param-reassign
        userFeature.allowed = false;
        // eslint-disable-next-line no-param-reassign
        userFeature.status = undefined;
      });
      this.cleanUserFilters();
    },
    expandDetailSection(section) {
      this.cancelSectionChanges(section);
      this.extendedSectionDetailsId = section._id !== this.extendedSectionDetailsId ? section._id : ''; // vacio para cuándo se colapsa una sección
    },
    onChangeSelectedSectionMode(section) {
      this.cleanUserFeatures();
      this.getUserFeaturesToShow(section);
    },
    checkExtended(section) {
      return section._id === this.extendedSectionDetailsId;
    },
    getFilteredTags(type, text) {
      const tags = type === 'section' ? this.sectionTagsList : this.userFeaturesAllTagList;
      const listTags = tags.filter(tag => {
        return tag
          .toString()
          .toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
      if (type === 'section') this.filteredSectionTags = listTags;
      else this.userFeaturesTagList = listTags;
    },
    createSection() {
      const random = new Date().getTime();
      const name = `Empty ${random}`;
      const description = 'Empty';
      const tags = [];
      const read = [];
      const write = [];
      const newSection = {
        _id: random,
        new: true,
        name,
        originalName: name,
        description,
        originalDescription: description,
        tags,
        originalTags: tags,
        read,
        write
      };
      this.sections.unshift(newSection);
      this.cleanSectionFilters();
    },
    sortUserFeatures() {
      const sortUserFeaturesByName = (a, b) => {
        const map = { nav: 1, endpoint: 3, element: 2 };
        return map[a.name.split('.')[0]] - map[b.name.split('.')[0]];
      };
      if (this.userFeaturesToShow.length) {
        const userFeaturesAdd = this.userFeaturesToShow.filter(feature => feature.status === 'add').sort(sortUserFeaturesByName);
        const userFeaturesDelete = this.userFeaturesToShow.filter(feature => feature.status === 'delete').sort(sortUserFeaturesByName);
        const userFeaturesPreserve = this.userFeaturesToShow.filter(feature => feature.status === 'preserve').sort(sortUserFeaturesByName);
        const userFeaturesOthers = this.userFeaturesToShow.filter(feature => !['add', 'delete', 'preserve'].includes(feature.status)).sort(sortUserFeaturesByName);
        this.userFeaturesToShow = userFeaturesPreserve.concat(userFeaturesAdd).concat(userFeaturesDelete).concat(userFeaturesOthers);
      }
    },
    // Arroja true si hay coincidencia en alguno de los dos elementos
    compareArrays(arrayOne, arrayTwo) {
      // eslint-disable-next-line no-param-reassign
      if (typeof arrayTwo === 'string') arrayTwo = arrayTwo.toLowerCase();
      // eslint-disable-next-line no-param-reassign
      else if (Array.isArray(arrayTwo)) arrayTwo = arrayTwo.map(element => element.toLowerCase());
      return arrayOne.some(elementOne => arrayTwo.includes(elementOne.toLowerCase()));
    },
    saveOriginalsSectionValues(section) {
      // eslint-disable-next-line no-param-reassign
      section.originalTags = JSON.parse(JSON.stringify(section.tags));
      // eslint-disable-next-line no-param-reassign
      section.originalName = section.name;
      // eslint-disable-next-line no-param-reassign
      section.originalDescription = section.description;
      return section;
    },
    setSections() {
      const sectionsTagsArray = this.sections.reduce((acc, section) => acc.concat(section.tags), []);
      this.sectionTagsList = Array.from(new Set(sectionsTagsArray));
      this.filteredSectionTags = this.sectionTagsList;
      this.sections = this.sections.map(section => this.saveOriginalsSectionValues(section));
      this.sectionToShow = this.sections;
    },
    async getSections() {
      try {
        this.sections = await getAllUserFeatureSections();
        this.setSections();
      } catch (_error) {
        this.showError();
      }
    },
    async getFeatures() {
      try {
        this.userFeatures = await getAllUserFeatures();
        const tagsArray = this.userFeatures.reduce((acc, feature) => acc.concat(feature.tags), []);
        this.userFeaturesAllTagList = Array.from(new Set(tagsArray));
        this.userFeaturesTagList = Array.from(new Set(tagsArray));
      } catch (_error) {
        this.showError();
      }
    }
  }
};
</script>

<style scoped>

h3 {
  padding: 0;
  margin: 0;
}

#activate-button {
  width: 100px;
}

.user-item {
  overflow: inherit;
}

.fa-location-dot {
  color: #00CCD1;
}

.tootip-title {
  font-weight: bold;
}

.input .is-other {
  outline: none !important;
  background-color: #dfe !important;
  border: 0 !important;
}

.check {
  margin-top: 0.331rem;
}

.section-detail {
  display: flex;
  justify-content: space-between;
}

.feature {
  margin-bottom: 1.1rem;
  display: block;
  overflow: visible;
}

.feature:last-child {
  margin-bottom: 0;
}

.text-info {
  display: grid;
  grid-template-columns: 130px 120px 200px 170px 12px 100px 100px;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  gap: 1rem;
}

.text {
  width: 5rem;
}

.default-client-header {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr));
  gap: 0rem 1rem;
  place-items: center;
  color: var(--primary);
  font-weight: 600;
}

.default-client-header .header-name {
  justify-self: start;
}

.default-client-header .button {
  justify-self: end;
}

@media (max-width: 1370px){
  .text-info{
    display: block;
    text-align: center;
  }
  .tag {
    margin: 0px auto;
  }
  .text {
    margin: 0px auto;
  }
}

</style>
